module.exports = __webpack_public_path__ + "img/slide1.f6fd20e6.jpg";